import formatFileSize from './utils'

const messages = {
  _default: () => `valor não é válido`,
  after: (field, [target, inclusion]) =>
    `deverá ser maior ${inclusion ? 'ou igual a' : ''}${target}.`,
  alpha_dash: () =>
    `o campo poderá conter caracteres alfanuméricos, bem como traços e sublinhados.`,
  alpha_num: () =>
    `o campo deverá conter apenas caracteres alfanuméricos.`,
  alpha_spaces: () =>
    `o campo deverá conter apenas caracteres alfabéticos assim como os espaços.`,
  alpha: () => `o campo deverá conter apenas caracteres alfabéticos.`,
  before: (field, [target, inclusion]) =>
    `deverá ser menor ${inclusion ? 'ou igual a ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `o campo deverá estar entre ${min} e ${max}.`,
  confirmed: () => `confirmação não corresponde.`,
  credit_card: () => `o campo é inválido.`,
  date_between: (field, [min, max]) =>
    `deverá estar entre ${min} e ${max}.`,
  date_format: (field, [format]) =>
    `deverá estar em formato ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `o campo deverá er numérico e poderá conterer ${
           !decimals || decimals === '*' ? '' : decimals
    } decimal points.`,
  digits: (field, [length]) =>
    `o campo deverá ser numérico e conter exatamente ${length} digitos.`,
  dimensions: (field, [width, height]) =>
    `o campo deverá ser ${width} pixels por ${height} pixels.`,
  email: () => `o campo deverá ser um e-mail válido.`,
  ext: () => `o campo deverá ser um ficheiro válido.`,
  image: () => `o campo deverá ser uma imagem válida.`,
  in: () => `o campo deverá ser um valor válido.`,
  integer: () => `o campo deverá ser um número inteiro válido.`,
  ip: () => `o campo deverá ser um endereço IP válido.`,
  length: (field, [length, max]) => {
    if (max) {
      return `extensão deve ser entre ${length} e ${max}.`
    }

    return `extensão deve ser ${length}.`
  },
  max: (field, [length]) =>
    `o campo não deve ser maior que ${length} caracteres.`,
  max_value: (field, [max]) => `o campo deve ser ${max} ou menor`,
  mimes: () => `o campo deve ter um tipo de ficheiro válido.`,
  min: (field, [length]) =>
    `o campo de ter pelo menos ${length} caracteres.`,
  min_value: (field, [min]) => `o campo de ser ${min} ou maior.`,
  not_in: () => `o campo deve ser um valor válido.`,
  numeric: () => `o campo deve conter apenas caracteres numéricos.`,
  regex: () => `o formato do campo é inválido.`,
  required: () => `o campo é requerido`,
  size: (field, [size]) =>
    `o tamanho deverá ser menor a ${formatFileSize(size)}.`,
  url: () => `o campo não é uma URL válida.`,
  fullName: () => 'não é válido (nome, primeiro nome e max 20. caracteres)',
  emailInput: () => 'o campo deverá ser um e-mail válido.',
  fullNamePerCountry: () => 'não é válido (nome, primeiro nome e max 18. caracteres)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'pt',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/pt.js